<template>
  <div v-loading="loading" element-loading-spinner="atom-audit-loader">
    <div style="position: relative; float: right; margin: 0px 0px -10px 0px;">
      <el-dropdown
        trigger="click"
        @command="
          command => {
            this.$emit('handleTableCommands', { command: command, ref: 'RebuttalsTable', csvName: 'rebuttals_table', headers: [], excludeHeaders: ['Details'] })
          }
        "
      >
        <span class="el-dropdown-link">
          <i title="table actions" class="mdi mdi-dots-horizontal" style="font-size: 20px; cursor: pointer;"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="download">Download</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <RebuttalsTable rebuttalType="AUDITOR" :tableData="tableData" :hideDetails="hideDetails" :updateAcctList="updateAcctList" />
    <el-dialog :visible.sync="dialogVisible" center destroy-on-close width="75%">
      <accountList v-if="dialogVisible" :header="detailsHeader" :drgTableIds="subDrgTableIds" :showRebuttalStatus="true"></accountList>
    </el-dialog>
  </div>
</template>

<script>
  import axios from '@/utilities/axios-global'
  import { mapState } from 'vuex'
  import accountList from './accoutList'
  import RebuttalsTable from './components/RebuttalsTable'

  export default {
    name: 'IPRebuttalsByAuditor',
    props: ['drgTableIds', 'dashboards', 'hideDetails', 'codeType'],
    data: function() {
      return {
        tableData: [],
        loading: false,
        dialogVisible: false,
        detailsHeader: '',
        subDrgTableIds: []
      }
    },
    components: {
      accountList,
      RebuttalsTable
    },
    methods: {
      async getData() {
        const payload = {
          drgTableIds: this.drgTableIds
        }
        try {
          this.loading = true
          const response = await axios.post(`${this.baseApiUrl}/reports/dashboard/inpatientRebuttalOutcomesByAuditor`, payload)
          this.tableData = response.data
        } catch (err) {
          this.tableData = []
        } finally {
          this.loading = false
        }
      },
      updateAcctList(row) {
        this.detailsHeader = row.auditor
        this.subDrgTableIds = row.accountNumbers
        this.dialogVisible = !this.dialogVisible
      }
    },
    computed: {
      ...mapState('user/', ['baseApiUrl'])
    },
    mounted: async function() {
      await this.getData()
    },
    watch: {
      drgTableIds: async function() {
        await this.getData()
      }
    }
  }
</script>

<style scoped></style>
